import React from "react"
import {createStyles, makeStyles, Grid} from "@material-ui/core"
import moment from "moment"

const useStyles = makeStyles(() =>
    createStyles({
        section: {
            bottom: 0,
            display: "none",
            justifyContent: "space-evenly",
            left: 0,
            marginTop: "5rem",
            width: "100%",
            ['@media print']: {
                display: "flex",
                position: "relative", 
                bottom: "auto",
                marginTop: "3rem",
            }
        },
        copyrightSection:{
            fontSize: 12,
            marginLeft: "15px"

        },
        PrintedSection:{
            fontSize:12,
        }
    })
)

export const ReportPrintFooter = () => {
    const classes = useStyles()

    return (
        <Grid container={true} alignItems={"flex-end"}>
            <div className={classes.section}>
                <div>
                    <a href="www.avantassessment.com" style={{textDecoration: "none"}}>www.avantassessment.com</a>
                </div>
                <div className={classes.copyrightSection}>
                    Copyright &copy; {moment().format("YYYY")} Avant Assessment, LLC. All rights reserved.
                </div>
                <div className={classes.PrintedSection}>
                    Printed on: {moment().format("MMMM D, YYYY")}
                </div>
            </div>
        </Grid>
    )
}

